export enum SORT_TYPE {
  ASC,
  DESC,
}

export interface TableSortIconProps {
  type?: SORT_TYPE;
}
